import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Carousel } from '@platzi/ui';
import { TitleSection, Tabs } from '../';
import { BlogpostsCard } from './BlogpostsCard';
import styles from './Blogposts.module.sass';

export const Blogposts = () => {
  const { t } = useTranslation();
  const content = useSelector((state) => state.get('community').get('tabCommunity').get('blogposts'))?.toJS() || [];
  const [contentToShow, setContentToShow] = useState('popular');

  if (content.populars.length === 0) return null;

  const renderCards = () => {
    switch (contentToShow) {
      case 'popular':
        return content.populars?.map((item, index) => <BlogpostsCard key={`SchoolBlog-${index}`} {...item} />);
      case 'new':
        return content.news?.map((item, index) => <BlogpostsCard key={`SchoolBlog-${index}`} {...item} />);
      default:
        return content.populars?.map((item, index) => <BlogpostsCard key={`SchoolBlog-${index}`} {...item} />);
    }
  };

  return (
    <section className={styles.Blogposts} id="blogposts">
      <TitleSection title={t('escuela.blogposts.title')}>
        <a className={styles.Link} href="/blog/">
          {t('escuela.blogposts.link')} <FontAwesomeIcon icon={faArrowRight} />
        </a>
      </TitleSection>
      <Tabs handleClick={setContentToShow} activeTab={contentToShow} />
      <Carousel elements={renderCards()} />
    </section>
  );
};
